import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import GroupDocuments from '../../Groups/GroupDocuments';
import Loading from '../../Shared/ResourceIndex/Loading';
import { TooltipContextProvider } from '@sw-sw/lib-ui';
import ProjectPermissionContext from '../../../contexts/ProjectPermissionContext';
import { useProjectBmpDocuments } from '../../../hooks/projectDetails';
import AppContext from '../../../contexts/AppContext';
import projectApi from '../../../utils/api/project';
import ProjectContext from '../../../contexts/ProjectContext';
import clientApi from '../../../utils/api/client';
import { getProjectConfigHelpers } from '../Forms/projectFormSchema';

export interface IBmpDetailsProps {
  groupId: number;
  projectId: number;
}
const BmpDetails: React.FC<IBmpDetailsProps> = ({ groupId, projectId }) => {
  const projectPermissionContext = useContext(ProjectPermissionContext);
  const bmpDetailsQuery = useProjectBmpDocuments(projectId, groupId);
  const [docs, setDocs] = useState<any>([]);
  const projectContext = useContext(ProjectContext)
  const [data, setData] = useState<any>([])
  const [clientData, setClientData] = useState([])
  const clientId = projectContext.project && projectContext.project.client_id

  const getDocuments = async () => {
    try {
      const response = await projectApi.getDocs(projectId, 'Fixed Details')
      
      setData(response)      
      const getData = response.documentTypes.filter((e: { name: string; }) => e.name === "Fixed Details Project")[0]
      const newArr = response.regulations.filter((e: { docTypeName: string; }) => e.docTypeName !== "Regulations")
      if (getData) setDocs([...newArr, ...getData.documents]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (projectId) {
      getDocuments()
    }
  }, [projectId]);

  useEffect(() => {    
    const fetchClientData = async() => {      
      try {        
        if(!data || !clientId || !projectContext ||!projectContext.project?.doc_type_group_id) return;

        clientApi.documentGroups.getDocTypeGroupItems(clientId, projectContext.project.doc_type_group_id)
        .then((res) => res.map((ele:any) => ele.doc_type_id))
        .then((res) => data && data.documentTypes && data.documentTypes.filter((ele: { id: number; }) => res.includes(ele.id)))
        .then(res => setClientData(res))
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    if (clientId && data?.documentTypes && projectContext && projectContext.project?.doc_type_group_id) {
      fetchClientData()
    }
  }, [clientId, data])


  const auth = useContext(AppContext).get('user');
  const { hasDocEditing } = getProjectConfigHelpers(
    (projectContext.project?.project_config || 'full') as any,
  );

  if (!bmpDetailsQuery.data) {
    return <Loading what='BMP Details' />;
  }

  const refetchData = (_file: any, _scope: any, groupDocId?: any) => {
    if(groupDocId === 0){      
      getDocuments()
    }
    else bmpDetailsQuery.refetch()
  }

  if (bmpDetailsQuery.data.length) {
    return (
      <TooltipContextProvider>
        <GroupDocuments
          scope='bmp'
          documentGroups={bmpDetailsQuery.data}
          document_group_id={groupId}
          onDocumentUpload={refetchData}
          onDocumentDelete={refetchData}
          onDocumentEdit={refetchData}
          canRename={            
            auth.roleName === 'Regional Manager (External)'
            ? false
            : !projectPermissionContext.readOnly
          }
          readOnly={projectPermissionContext.readOnly}
          label={'Project Documents'}
          roleCanDelete={
            auth.roleName === 'Regional Manager (External)'
              ? false
              : !projectPermissionContext.readOnly
          }
          replace={
            auth.roleName === 'Regional Manager (External)'
              ? false
              : !projectPermissionContext.readOnly
          }
          fixedDetails={docs}
          bmpProject={true}
          clientData={clientData ? clientData : []}
          canEdit={hasDocEditing}
        />
      </TooltipContextProvider>
    );
  } else {
    if (auth.roleName === 'Public' || auth.roleName === 'Public No Image') {
      return <p>No control measures have been added to the active site map.</p>;
    }
    
    return (
      <>
        <TooltipContextProvider>
          <GroupDocuments
            scope='bmp'
            fixedDetails={docs}
            bmpProject={true}
            clientData={clientData ? clientData : []}
            onDocumentUpload={refetchData}
            label={'Project Documents'}
            roleCanDelete={
              auth.roleName === 'Regional Manager (External)'
                ? false
                : !projectPermissionContext.readOnly
            }
            onDocumentDelete={refetchData}
            onDocumentEdit={refetchData}
            canRename={            
              auth.roleName === 'Regional Manager (External)'
              ? false
              : !projectPermissionContext.readOnly
            }
              replace={
              auth.roleName === 'Regional Manager (External)'
                ? false
                : !projectPermissionContext.readOnly
            }
            canEdit={hasDocEditing}
            />
        </TooltipContextProvider>

        <p>
          No control measures have been added to the active site map.{' '}
          <Link to={`/projects/${projectId}/active-site-map`}>Click here</Link>{' '}
          to manage site map control measures.
        </p>
      </>
    );
  }
};

export default BmpDetails;
